import {Stack, useTheme} from "@mui/material";
import {Logo} from "./Logo";
import {PriceBlock} from "./PriceBlock/PriceBlock";
import useMediaQuery from "@mui/material/useMediaQuery";
import ResetBlock from "./ResetBlock/ResetBlock";
import {HEADER_HEIGHT} from "../../constants";
import {memo} from "react";
import {ProSliderBlock} from "./ProSliderBlock/ProSliderBlock";
import {UndoRendoBlock} from "./UndoRendoBlock/UndoRendoBlock";
import {SaveButton} from "../SaveButton/SaveButton";


export const Header = memo(() => {
    const theme = useTheme();
    const matchesXL = useMediaQuery(theme.breakpoints.up("xl"));

    return (
        <Stack direction={"row"} height={`${HEADER_HEIGHT}px`} px={matchesXL ? "120px" : "40px"} alignItems="center" justifyContent="space-between" id='header'
            position={'absolute'}
            width={'100%'}
            zIndex={2}
            bgcolor={'#fff'}
            overflow={'hidden'}
        >

            <Stack direction={"row"} alignItems="center" justifyContent="space-between" width={'30%'}>
                <Logo />
                <ProSliderBlock />
            </Stack>
            <Stack direction={"row"} width={'50%'} alignItems="center" height={'100%'}>
                <UndoRendoBlock />
                <ResetBlock />
                <SaveButton />
                <PriceBlock />
            </Stack>


            {/* <Steps /> */}

        </Stack>
    );
})
